import { Link } from "react-router-dom";
import { useConfig } from "@/context/ConfigContext";

export const Footer = () => {
  const config = useConfig();
  return (
    <footer className="border-t border-border bg-foreground text-background" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-5 py-12 lg:px-8">
        <div className="grid gap-8 md:grid-cols-3">
          <div>
            <span className="font-heading text-lg font-extrabold tracking-tight">
              VISA<span className="text-primary">FLIGHT</span>
            </span>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-background/70">
              Confirmed airline reservations for visa applications. A reservation service — not an airline, embassy, or
              ticket seller.
            </p>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-background/60">Service</h4>
            <ul className="mt-3 space-y-2 text-sm text-background/80">
              <li><a href="/#how-it-works" className="hover:text-primary">How It Works</a></li>
              <li><a href="/#pricing" className="hover:text-primary">Pricing</a></li>
              <li><a href="/#faq" className="hover:text-primary">FAQ</a></li>
              <li><Link to="/order" className="hover:text-primary">Order Now</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-background/60">Legal</h4>
            <ul className="mt-3 space-y-2 text-sm text-background/80">
              <li><Link to="/privacy" className="hover:text-primary">Privacy Notice</Link></li>
              <li><Link to="/terms" className="hover:text-primary">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 border-t border-background/15 pt-6 text-xs leading-relaxed text-background/50">
          <p>
            VisaFlight provides a confirmed airline reservation for visa application documentation. It is not a purchased
            airline ticket, and VisaFlight does not guarantee visa approval. Requirements vary by embassy and consulate;
            please confirm current requirements before ordering.
          </p>
          <p className="mt-3">© {new Date().getFullYear()} {config.brand_name}. Nigeria. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
